import { Flex } from '@pancakeswap/uikit'
import styled, { css, keyframes } from 'styled-components'
import { SubMenuItemProps } from './types'

// Animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
`

// Active Styles
const activeBackground = css`
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.25);
`

const activeMenuItem = css`
  border-radius: 200px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%);
`

const activeIcon = css`
  border: 0.689px solid #f59c53;
  background: #1c1c1a;
  box-shadow: 0px 6.251px 12.501px rgba(245, 156, 83, 0.05);
  backdrop-filter: blur(27.552553176879883px);
`

export const Aside = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  width: 300px;
  padding: 64px 24px 24px 24px;
  flex-shrink: 0;
  // align-self: stretch;
  background: linear-gradient(0deg, #222, #222), rgba(255, 255, 255, 0.05);
  box-shadow: inset 0px 8px 32px rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  animation: ${fadeIn} 0.4s ease-out;
  height: 100vh; /* Default to full viewport height */
  transition: height 0.3s ease;
  overflow: hidden;

  @media (max-width: 1280px) {
  }

  /* On screens smaller than 768px, position sidebar at the bottom */
  @media (max-width: 768px) {
    position: fixed;
    top: calc(100vh - 45px);
    left: 0;
    height: fit-content; /* Allow the height to adjust based on content */
    width: 100%;
    padding: 2px 10px;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background: linear-gradient(0deg, #222, #222), rgba(255, 255, 255, 0.05);
    box-shadow: inset 0px 8px 32px rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(4px);
    z-index: 20;
  }
`

export const LogoWrapper = styled(Flex)`
  display: flex;
  height: 44px;
  align-items: center;
  gap: 4.659px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const LogoText = styled.span`
  color: #fff;
  font-family: 'Newake', sans-serif;
  font-size: 34.94px;
  font-weight: 400;
  line-height: normal;
`

export const SideMenuWrapper = styled(Flex)`
  display: flex;
  width: 240px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  gap: 84px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 4fr 1fr;
    align-self: stretch;
    justify-content: space-around;
    align-items: center;
    gap: 0;
  }
`

export const SideItemWrapper = styled(Flex)<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  transition: background 0.3s ease;

  ${({ $isActive }) => $isActive && activeBackground};

  @media (max-width: 768px) {
    background: transparent;
  }

  & :hover {
    opacity: 0.8;
  }
`
export const SideMenuItem = styled(Flex)<{ $isActive: boolean }>`
  display: flex;
  align-self: stretch;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease;

  ${({ $isActive }) => $isActive && activeMenuItem};

  @media (max-width: 768px) {
    background: transparent;
    justify-content: center;
    padding: 0;
  }
`

export const MenuItemWrapper = styled(Flex)`
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`

export const SubMenuWrapper = styled(Flex)<{ $isActive: boolean }>`
  display: none;

  ${({ $isActive }) =>
    $isActive &&
    css`
      display: flex;
      padding: 8px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      animation: ${fadeIn} 0.3s ease-out;
    `};

  @media (max-width: 768px) {
    display: none;
  }
`
export const SubMenuItem = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive',
})<SubMenuItemProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
  color: ${({ isActive }) => (isActive ? '#F59C53' : '#FFF')};
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};

  &:hover {
    opacity: 0.8;
  }
`

export const IconWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  display: flex;
  // padding: 12.501px;
  width: 43.755px;
  height: 43.755px;
  justify-content: center;
  align-items: center;
  gap: 6.251px;
  border-radius: 100px;
  border: 0.5px solid rgba(255, 255, 255, 0.2);
  // background: rgba(28, 28, 26, 0.2);
  // box-shadow: 0px 6.251px 12.501px rgba(0, 0, 0, 0.06);
  // backdrop-filter: blur(27.552553176879883px);
  transition: all 0.3s ease;

  ${({ isActive }) => isActive && activeIcon};

  @media (max-width: 768px) {
    border: none;
    background: transparent;
    box-shadow: none;
    backdrop-filter: none;
    width: fit-content;
    height: fit-content;
  }
`

export const SubIconWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  display: flex;
  position: relative;
  width: 43.755px;
  height: 43.755px;
  padding: 12.501px;
  justify-content: center;
  align-items: center;
  gap: 6.251px;
  flex-shrink: 0;
  border-radius: 100px;
  // box-shadow: 0px 6.251px 12.501px 0px rgba(0, 0, 0, 0.06);
  // backdrop-filter: blur(27.552553176879883px);
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    box-shadow: none;
    backdrop-filter: none;
  }
`

export const LogoutBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  transition: background 0.3s;
  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    height: auto;
    align-items: center;
    justify-content: center;
  }
`

export const BlurIconWrapper = styled(Flex)`
  position: absolute;
  left: 0;
  top: 0;
  filter: blur(9.14285659790039px);
  z-index: 0;
`

export const MenuBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    flex: 1;
  }
`
export const MenuText = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  text-align: right;
  font-family: Satoshi;
  font-size: 18px;
  font-style: normal;
  line-height: 134%;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  ${({ isActive }) =>
    isActive &&
    `
  color: #fff;
  font-weight: 500;
  `};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

export const WalletCardTop = styled(Flex)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`
export const WalletCardTitle = styled.span`
  color: #fff;
  text-align: right;

  /* Body/Small */
  font-family: Satoshi;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 134%; /* 21.44px */
  letter-spacing: -0.08px;
`

export const WalletCardAmount = styled.span`
  color: #fff;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 132%; /* 21.12px */
  letter-spacing: 0.32px;
`

export const WalletCardActions = styled(Flex)`
  display: flex;
  // width: 220px;
  align-items: center;
  align-self: stretch;
  gap: 8px;
`

export const WalletCardButton = styled(Flex)`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 100px;
  border: 1px solid var(--Brand-Primary, #f59c53);
  background: var(--Brand-Primary, #f59c53);
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`

export const WalletCardButtonText = styled.span`
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Satoshi;
  font-size: 10px; // originally 10px
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 180% */
`

export const SideDownIconWrapper = styled(Flex)`
  display: flex;
  padding: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`
